import { useCallback } from 'react';
import FJGenerateButton from '../../../../common/components/FJGenerateButton/FJGenerateButton';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import FJActionCommon from '../../../../redux/action/FJActionCommon';
import PropTypes from 'prop-types';
import useLocalStore from '../../../../hooks/useLocalStore';

const FJGenerateButtonContainer = props => {
    useLocalStore();
    const { text, className, useCredit, customFreeNumCreation, disabled } = props;
    const dispatch = useDispatch();

    const taskStatus = useSelector(state => state.common.taskStatus);
    const isProjectLoading = useSelector(state => state.common.isProjectLoading);
    const freeNumCreation = useSelector(state => state.common.freeNumCreation);
    const creditNumber = useSelector(state => state.common.creditNumber);

    const _onGenerate = useCallback(() => {
        dispatch(FJActionCommon.generateAction());
    }, [dispatch]);

    const useFreeCreation = customFreeNumCreation ? customFreeNumCreation : freeNumCreation;

    return (
        <FJGenerateButton
            taskStatus={taskStatus}
            isProjectLoading={isProjectLoading}
            freeNumCreation={useFreeCreation}
            creditNumber={creditNumber}
            useCredit={useCredit}
            text={text}
            className={className}
            onClick={_onGenerate}
            isFree={useFreeCreation > 0 && useCredit > creditNumber}
            disabled={disabled}
        />
    );
};

FJGenerateButtonContainer.propTypes = {
    text: PropTypes.string,
    className: PropTypes.string,
    useCredit: PropTypes.number,
    customFreeNumCreation: PropTypes.number,
    disabled: PropTypes.bool,
};

export default FJGenerateButtonContainer;
